import { FtTableHeadData } from "components/common/table/FtTable";
import { TableActionIcons } from "components/common/table/tableActionIcons/TableActionIcons";
import { typeMapper } from "utility";

export const headData: FtTableHeadData[] = [
  {
    id: "accountNumber",
    label: "",
    alwaysShow: false,
  },
  {
    id: "paymentDate",
    label: "",
    alwaysShow: true,
    sortable: true,
    dynamicRender: ({ t, value }) => {
      return t(`common:date_format`, {
        value,
      });
    },
  },
  {
    id: "paymentMethodType",
    label: "",
    sortable: true,
    dynamicRender({ value, data, t }) {
      if (data.paymentMethodName) {
        return data.paymentMethodName;
      }
      return value
        ? t(`common:${typeMapper(value, "paymentMethodTypeReverse")}_label`)
        : "-";
    },
  },
  {
    id: "amountPaid",
    label: "",
    alwaysShow: true,
    sortable: true,
    dynamicRender: ({ t, value }) => {
      return t(`common:currency_format`, {
        value: value || 0,
      });
    },
  },
  {
    id: "status",
    label: "",
    sortable: true,
    dynamicRender: ({ value, data }) => {
      if (data.schedulePayment) {
        return typeMapper(value!, "ScheduleStatusReverse");
      } else {
        return typeMapper(value!, "PaymentStatusReverse");
      }
    },
  },
  {
    id: "amountDue",
    label: "",
    sortable: true,
    dynamicRender: ({ value, t }) => {
      return t(`common:currency_format`, {
        value: value || 0,
      });
    },
  },
  {
    id: "confirmationNumber",
    label: "",
    sortable: true,
    dynamicRender: ({ value, t }) => {
      return value ? value : "-";
    },
  },
  {
    id: "action",
    label: "",
    align: "center",
    type: "SHARE-DOWMLOAD",
    dynamicRender: (props) =>
      props?.data?.status !== 10 && props?.data?.status !== 6 ? <TableActionIcons {...props} /> : "",
  },
];

export const headDataWidget: FtTableHeadData[] = [
  {
    id: "accountNumber",
    label: "",
    alwaysShow: false,
  },
  {
    id: "paymentDate",
    label: "",
    sortable: true,
    alwaysShow: true,
    dynamicRender: ({ t, value }) => {
      return t(`common:date_format`, {
        value,
      });
    },
  },
  {
    id: "paymentMethodType",
    label: "",
    sortable: true,
    dynamicRender({ value, data, t }) {
      if (data.paymentMethodName) {
        return data.paymentMethodName;
      }
      return value
        ? t(`common:${typeMapper(value, "paymentMethodTypeReverse")}_label`)
        : "-";
    },
  },
  {
    id: "amountPaid",
    label: "",
    sortable: true,
    alwaysShow: true,
    dynamicRender: ({ t, value }) => {
      return value
        ? t(`common:currency_format`, {
            value,
          })
        : "-";
    },
  },
  {
    id: "status",
    label: "",
    sortable: true,
    dynamicRender: ({ value, data }) => {
      if (data.schedulePayment) {
        return typeMapper(value!, "ScheduleStatusReverse");
      } else {
        return typeMapper(value!, "PaymentStatusReverse");
      }
    },
  },
  {
    id: "action",
    label: "",
    type: "SHARE-DOWMLOAD",
    align: "center",
    dynamicRender: (props) =>
      props?.data?.status !== 10 && props?.data?.status !== 6 ? <TableActionIcons {...props} /> : "",
  },
];
